// extracted by mini-css-extract-plugin
export default {"link":"BasketDetail_link__-3Cro","price":"BasketDetail_price__hdpBH","theme-grayscale":"BasketDetail_theme-grayscale__1wokN","points":"BasketDetail_points__l7uEX"};